<div class="qu-container">

  <!-- ─── Filter Bar ─── -->
  <div class="qu-action-bar th-filter-bar">
    <div class="th-filters">
      <div class="th-filter">
        <label class="qu-label">Status</label>
        <select [(ngModel)]="filterStatus" (ngModelChange)="onFilterChange()" class="qu-select">
          <option value="">All</option>
          <option *ngFor="let s of statusOptions" [value]="s">{{ statusLabel(s) }}</option>
        </select>
      </div>

      <div class="th-filter">
        <label class="qu-label">From</label>
        <input type="date" [(ngModel)]="filterDateFrom" (ngModelChange)="onFilterChange()" class="qu-input th-date" />
      </div>

      <div class="th-filter">
        <label class="qu-label">To</label>
        <input type="date" [(ngModel)]="filterDateTo" (ngModelChange)="onFilterChange()" class="qu-input th-date" />
      </div>

      <div class="th-filter">
        <label class="qu-label">User ID</label>
        <input type="text" [(ngModel)]="filterUser" (ngModelChange)="onFilterChange()"
               placeholder="Created by..." class="qu-input th-user" />
      </div>

      <button *ngIf="hasFilters()" class="qu-btn qu-btn-secondary" (click)="clearFilters()">Clear</button>
    </div>

    <button class="qu-btn qu-btn-secondary" (click)="fetchData()">Refresh</button>
  </div>

  <!-- ─── Table ─── -->
  <div class="qu-table-wrap">

    <!-- Skeleton (loading) -->
    <table *ngIf="loading" class="qu-table">
      <thead>
        <tr>
          <th class="qu-th">Document Name</th>
          <th class="qu-th">Operation</th>
          <th class="qu-th">Status</th>
          <th class="qu-th">By</th>
          <th class="qu-th">Created At</th>
          <th class="qu-th">Started At</th>
          <th class="qu-th">Completed At</th>
          <th class="qu-th">Details</th>
          <th class="qu-th qu-th-action">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sk of skeletonRows" class="qu-skeleton-row">
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-xs"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-xs"></div></td>
        </tr>
      </tbody>
    </table>

    <!-- Data Table -->
    <table *ngIf="!loading" class="qu-table">
      <thead>
        <tr>
          <th class="qu-th">Document Name</th>
          <th class="qu-th">Operation</th>
          <th class="qu-th">Status</th>
          <th class="qu-th">By</th>
          <th class="qu-th">Created At</th>
          <th class="qu-th">Started At</th>
          <th class="qu-th">Completed At</th>
          <th class="qu-th">Details</th>
          <th class="qu-th qu-th-action">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of data; let idx = index"
          class="qu-tr"
          [ngClass]="getRowClass(idx)">

          <td class="qu-td">
            {{ row.documentName || '—' }}
            <span *ngIf="row.retryCount > 0" class="th-retry-tag" title="Retried {{ row.retryCount }} time(s)">↻ {{ row.retryCount }}</span>
          </td>
          <td class="qu-td">
            <span class="op-badge" [ngClass]="row.operation === 'DELETE' ? 'op-delete' : 'op-add'">{{ row.operation }}</span>
          </td>
          <td class="qu-td">
            <span class="status-badge" [ngClass]="getStatusClass(row.status)">
              {{ statusLabel(row.status) }}
            </span>
          </td>
          <td class="qu-td">{{ row.createdByName || row.createdBy || '—' }}</td>
          <td class="qu-td">{{ formatDate(row.createdAt) }}</td>
          <td class="qu-td">{{ formatDate(row.startedAt) }}</td>
          <td class="qu-td">{{ formatDate(row.completedAt) }}</td>
          <td class="qu-td th-details" [title]="row.details || ''">{{ row.details || '—' }}</td>
          <td class="qu-td qu-td-action">
            <button *ngIf="canRetry(row)" class="qu-icon-btn qu-icon-btn-retry" (click)="retryTask(row)" title="Retry processing">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="23 4 23 10 17 10"/>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
              </svg>
            </button>
            <span *ngIf="!canRetry(row)">—</span>
          </td>
        </tr>

        <tr *ngIf="data.length === 0">
          <td colspan="9" class="qu-td qu-td-empty">No history found.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ─── Pagination (server-side) ─── -->
  <div class="qu-pagination">
    <div class="qu-page-nav">
      <button class="qu-btn qu-btn-page" [disabled]="page === 1" (click)="goToPage(page - 1)">Prev</button>
      <button class="qu-btn qu-btn-page" [disabled]="page >= totalPages" (click)="goToPage(page + 1)">Next</button>
      <span class="qu-page-info">Page {{ page }} of {{ totalPages }}</span>
    </div>

    <span class="qu-count">{{ totalRows }} operations</span>

    <div class="qu-rows-wrap">
      <span class="qu-label">Rows per page</span>
      <select [(ngModel)]="rowsPerPage" (ngModelChange)="onPageSizeChange()" class="qu-select">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
      </select>
    </div>
  </div>

</div>

<!-- ─── Toasts ─── -->
<div class="qu-toasts">
  <div
    *ngFor="let t of toasts"
    class="qu-toast"
    [ngClass]="t.type === 'success' ? 'qu-toast-success' : 'qu-toast-error'">
    <span class="qu-toast-icon" [ngClass]="t.type === 'success' ? 'qu-icon-success' : 'qu-icon-error'">
      {{ t.type === 'success' ? '✓' : '✕' }}
    </span>
    <span class="qu-toast-text">{{ t.message }}</span>
  </div>
</div>
